@for (option of rolesOptions; track option) {
  <sb-check-box
    class="role-option"
    [class.hidden]="option.dep && !getControl('roles').value.includes(option.dep)"
    [style.padding-left.em]="option.level * 2"
    [label]="getOptionLabel(option)"
    [isChecked]="getControl('roles').value.includes(option.name)"
    [isDisabled]="disabled"
    (modelChange)="onCheckBoxChanged(option)" />
}